import type { Fields } from "@smartsuite/smartsuite-client";
import { ValueDescription_T } from "@smartsuite/automation-engine-api";

export const ssTypes: Fields[] = [
  "statusfield",
  "singleselectfield",
  "multipleselectfield",
  "tagsfield",
  "yesnofield",
  "lookupfield",
  "textfield",
  "textareafield",
];

export const generalTypes: ValueDescription_T[] = [
  ValueDescription_T.STRING,
  ValueDescription_T.FILE_URL,
  ValueDescription_T.BOOL,
  ValueDescription_T.OUTPUT_LIST,
  ValueDescription_T.EMAIL,
  ValueDescription_T.SELECT,
  ValueDescription_T.MEMBER,
  ValueDescription_T.LINK,
  ValueDescription_T.PHONE,
  ValueDescription_T.FILE,
  ValueDescription_T.SCHEDULE,
  ValueDescription_T.SMARTDOC,
  ValueDescription_T.CHECKLIST,
  ValueDescription_T.TAG,
];
